// components/RoleChangeModal.jsx
import React, { useMemo, useState } from 'react';

export default function RoleChangeModal({ user, roles, onSave, onClose }) {
  // Normalize roles from backend: can be array of strings or array of role rows
  const options = useMemo(() => {
    if (!Array.isArray(roles)) return [];
    return roles.map((r) => {
      if (typeof r === 'string') return { role_id: undefined, role_name: r };
      // expect DB-like rows
      return {
        role_id: r.role_id,
        role_name: r.role_name || r.name || '',
      };
    }).filter(opt => opt.role_name);
  }, [roles]);

  // Preselect current role if available
  const currentName = Array.isArray(user?.roles) && user.roles.length ? user.roles[0] : '';
  const currentOpt = options.find(o => o.role_name === currentName);

  const [selected, setSelected] = useState(currentOpt?.role_id ?? '');

  const handleSubmit = (e) => {
    e.preventDefault();
    const opt = options.find(o => String(o.role_id ?? '') === String(selected));
    // Fallback: if role_id is undefined in your table for some reason, still send name
    if (!opt) return;
    onSave({ role_id: opt.role_id, role_name: opt.role_name });
  };

  return (
    <div className="modal-backdrop" style={{ zIndex: 'var(--z-modal-backdrop)' }}>
      <div className="modal-content" style={{ maxWidth: 420, minWidth: 300 }}>
        <h3>Change Role — {user?.username || user?.email || `User #${user?.user_id}`}</h3>
        <form onSubmit={handleSubmit}>
          <label style={{ display: 'block', marginBottom: 10 }}>
            <span style={{ display: 'block', fontWeight: 600, marginBottom: 6 }}>Select a role</span>
            <select
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
              required
              style={{ width: '100%', padding: 8 }}
            >
              <option value="" disabled>Select role</option>
              {options.map(opt => (
                <option key={`${opt.role_id ?? opt.role_name}`} value={opt.role_id ?? ''}>
                  {opt.role_name}
                </option>
              ))}
            </select>
          </label>

          <div style={{ display: 'flex', gap: 8, marginTop: 12 }}>
            <button type="button" onClick={onClose}>Cancel</button>
            <button type="submit">Save</button>
          </div>
        </form>
      </div>
    </div>
  );
}
